import type { ResultQuery } from "../../types/api";

export const DEFAULT_QUERY: ResultQuery = {
  view: "exceptions",
  status: [],
  reason: [],
  review_state: [],
  q: "",
  sort: "-status",
  page: 1,
  page_size: 50,
};
